import { Component, Input } from '@angular/core';
import { curveBasis } from 'd3-shape';
import { ScaleType } from '@swimlane/ngx-charts';

@Component({
  selector: 'app-area-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class AreaChartComponent  {
  @Input() chartData!: any;
  @Input() single!: any[];
  // chart options
  curve = curveBasis;
  showLabels = true;
  animations = true;
  colorScheme = {
    name: 'cool',
    selectable: true,
    group: ScaleType.Linear,
    domain: ['rgb(186,32,37)']
  };

  formatDate(date: number): string {
    return new Date(date).toISOString().substring(0, 10);
  }
}
